import {$document} from "./globals";
import {cModal} from "./c-modal-new";
import {FastMessage} from "./fastmessages-new";

require("./../plugins/star-rating/jquery.rating.pack");

const slider = $('.product-slider-nav');
if (slider.length) {
    import("./swiper").then(module => {
        module.productDetailSwiper(slider, $('.c-other_images'))
    })
}

const NearestShop = function (el) {
    this.position = null;
    this.parentElement = el;
    const _this = this;
    this.init = function init(ajax = true) {
        if (navigator.geolocation) {
            if (!_this.position) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    _this.position = position;
                    if (ajax) {
                        doajax();
                    }
                });
            } else {
                if (ajax) {
                    doajax();
                }
            }
        }
    }

    function doajax() {
        const productId = $('.productDetail-addToBasketButton .aButton').attr('data-product-id');
        if (productId && !isNaN(parseInt(productId))) {
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: CatalogPresenter + 'get-nearest-shop/',
                data: {
                    'latitude': _this.position.coords.latitude,
                    'longitude': _this.position.coords.longitude,
                    'productid': productId
                },
                success: function (data) {
                    if (typeof data.success !== undefined && data.success) {
                        const query = encodeURIComponent(data.shop.longitude + ',' + data.shop.latitude);
                        const html = $('<div class="c-nearest-shop"><span class="title">' + data.shop.title + ':</span><a href="https://mapy.cz/zakladni?x=' + data.shop.longitude + '&y=' + data.shop.latitude + '&z=17&source=coor&id=' + query + '" target="_blank"><span class="shop">' + data.shop.name + '</span></a></div>');
                        html.hide();
                        _this.parentElement.append(html);
                        html.slideDown();
                    }
                }
            });
        }
    }
}

let nearestShop;
// const $changing = $('.changing');
// if ($changing.length && $changing.length < 2) {
//     nearestShop = new NearestShop($changing);
//     nearestShop.init(false);
//     const radiosCount = $('.c-size-wrap input[type=radio]').length;
//     if (!radiosCount || radiosCount === 1) {
//         nearestShop.init();
//     }
// }

$('.productDetail-betterPrice').on('click', function (e) {
    e.preventDefault();
    const id_product = $(this).attr('data-product-id');
    const type = 'better_price';
    ShowContactFormForProduct(type, id_product);
});

$('.productDetail-question').on('click', function (e) {
    e.preventDefault();
    const oid_product = $(this).attr('data-product-id');
    const type = 'product_ask';
    ShowContactFormForProduct(type, oid_product);
});

if ($('.c-size-wrap:not(.is_set)').length) {

    $document.on('change', '.c-size-wrap:not(.is_set) input[type=radio]', function () {
        //aktualizovat skladovost...
        const $container = $('.changing');
        const id = $(this).attr('data-product-id');
        $('.c-nearest-shop').slideUp();
        $.ajax({
            url: CatalogPresenter + 'get-stock-and-price-block/?id=' + id,
            dataType: 'json',
            success: function (data) {
                if (typeof data.error != 'undefined') {
                    alert(data.error);
                } else {
                    const html = $(data.html);
                    $container.html(html.html());
                    if (typeof $.fn.plusMinusInput !== 'undefined') {
                        $('input.PlusMinusInput').plusMinusInput();
                    }
                    if (typeof nearestShop != "undefined") {
                        nearestShop.init();
                    }
                    if('retargetingConf' in window && retargetingConf.itemId !== id){
                        if (window.sznIVA && window.sznIVA.IS) {
                            window.sznIVA.IS.updateIdentities({
                                eid: data.email || null
                            });
                        }
                        retargetingConf.itemId = id.toString();
                        if (window.rc && window.rc.retargetingHit)
                            window.rc.retargetingHit(retargetingConf);
                    }
                    if('GA' in data){
                        gtag("event", "view_item", {
                            send_to: GA4,
                            ...data.GA
                        });
                        gtag("event", "view_item", {
                            send_to: GADS,
                            ...data.GA
                        });
                    }
                }
            }
        });
    });

    $('.c-size-wrap:not(.is_set) input[type=radio]:checked').trigger('change');

}

const setSizes = $('.c-size-wrap.is_set');

if (setSizes.length) {
    let promises = [];
    let containers = [];
    setSizes.find('input[type=radio]:checked').each(function () {
        const _ = $(this);
        containers.push(_.parent().siblings('.changing'));
        promises.push(
            $.ajax({
                url: CatalogPresenter + 'get-stock-set-product/?id=' + _.attr('data-product-id'),
                dataType: 'json',
            })
        )
    })
    if (promises.length) {
        $.when.apply($, promises)
            .done(function () {
                for (let i = 0, j = arguments.length; i < j; i++) {
                    if (typeof arguments[i][0].error != 'undefined') {
                        alert(arguments[i][0].error);
                    } else {
                        const html = $(arguments[i][0].html);
                        containers[i].replaceWith(html);
                    }
                }
            })
    }
    $document.on('change', '.c-size-wrap.is_set input[type=radio]', function () {
        //aktualizovat skladovost...
        const _ = $(this);
        const $container = _.parent().siblings('.changing');
        $.ajax({
            url: CatalogPresenter + 'get-stock-set-product/?id=' + _.attr('data-product-id'),
            dataType: 'json',
            success: function (data) {
                if (typeof data.error != 'undefined') {
                    alert(data.error);
                } else {
                    const html = $(data.html);
                    $container.replaceWith(html);
                }
                if('GA' in data){
                    gtag("event", "view_item", {
                        send_to: GA4,
                        ...data.GA
                    });
                    gtag("event", "view_item", {
                        send_to: GADS,
                        ...data.GA
                    });
                }
            }
        });
    });

}

$('.js-review').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const anchor = $('[data-tab-target="tab-reviews"]');
    $('html, body').animate({
        scrollTop: anchor.offset().top
    }, 1000);
    anchor.trigger('click');
});

export const AutoSubmitStar = function ($container) {
    //hodnoceni produktu pomoci kliknuti na hvezdy
    if ($container == null) {
        $container = $document;
    }
    $container.find('.auto-submit-star').rating({
        callback: function (value, link) {
            const information = $('.ProductRating .information');
            const saving = $('.ProductRating .saving');
            information.stop().fadeOut('fast', function () {
                saving.stop().fadeIn('fast');
            });
            $.ajax({
                method: "GET",
                dataType: "json",
                url: CatalogPresenter + "rate-product",
                data: {productId: $(this).attr('product-id'), rating: value},
                success: function (data) {
                    $('.ratingCount').html(data.responseCount);
                    $('.avgRating').html(data.responseAvgRating);
                },
                complete: function () {
                    setTimeout(function () {
                        saving.stop().fadeOut('fast', function () {
                            information.stop().fadeIn('fast');
                        });
                    }, 100);
                }
            });
        }
    });
}

AutoSubmitStar();

function ShowContactFormForProduct(type, id_product) {
    $.ajax({
        url: CatalogPresenter + 'get-contact-form-for-product/?id=' + id_product + '&type=' + type,
        dataType: 'json',
        success: function (data) {
            if (typeof data.html != "undefined") {
                cModal.open(data.title, data.html);
            }
        }
    });
}

window.HandleSubmitProductContactForm = function HandleSubmitProductContactForm(state, $bform, response_errors) {
    if (state !== 0 && state !== 2) {
        cModal.close();
        FastMessage.createMessage('Zpráva byla úspěšně odeslána. Ozveme se Vám co nejdříve.')
    }
}

